export default {
	leftLabel: ['static-field--left-label'],
	default: ['']
};
